export const saveLastPath = (path: string) => {
  try { sessionStorage.setItem('lastPath', path); } catch {}
};

export const saveLastApp  = (app: string)  => {
  try { sessionStorage.setItem('lastApp', app); } catch {}
};

export const getLastPath = (): string => {
  try { return sessionStorage.getItem('lastPath') || ''; }
  catch { return ''; }
};

export const getLastApp  = (): string => {
  try { return sessionStorage.getItem('lastApp') || ''; }
  catch { return ''; }
};
export const saveLastPath = (path: string) => {
  try { sessionStorage.setItem('lastPath', path); } catch {}
};

export const saveLastApp  = (app: string)  => {
  try { sessionStorage.setItem('lastApp', app); } catch {}
};

export const getLastPath = (): string => {
  try { return sessionStorage.getItem('lastPath') || ''; }
  catch { return ''; }
};

export const getLastApp  = (): string => {
  try { return sessionStorage.getItem('lastApp') || ''; }
  catch { return ''; }
};
